import React from 'react'


type DummyImageProps = React.HTMLAttributes<SVGElement> & {
  w?: number
  h?: number
  width?: string | number
  height?: string | number
}

const DummyImage: React.FunctionComponent<DummyImageProps> = ({ className, width, height, w = 2, h = 2 }) => (
  // ATTN width and height is required for Edge, 1 is hidden by style
  <svg
    className={className}
    width={width || w}
    height={height || h}
    viewBox={`0 0 ${w} ${h}`}
  />
)


export default DummyImage
